function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.952 8A6.667 6.667 0 111.62 8a6.667 6.667 0 0113.333 0zm-6.666.943L6.757 10.47l-.943-.942 1.529-1.53-1.529-1.528.943-.942 1.529 1.528L9.814 5.53l.943.942L9.228 8l1.53 1.529-.944.942-1.528-1.528z",
  fill: "#DCE1E5",
  fillOpacity: 0.42
});

var SvgError = function SvgError(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTciIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNyAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgaWQ9IkVycm9yIj4KPHBhdGggaWQ9IlZlY3RvciIgZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNC45NTI0IDcuOTk5OTJDMTQuOTUyNCAxMS42ODE4IDExLjk2NzYgMTQuNjY2NiA4LjI4NTY5IDE0LjY2NjZDNC42MDM3OSAxNC42NjY2IDEuNjE5MDIgMTEuNjgxOCAxLjYxOTAyIDcuOTk5OTJDMS42MTkwMiA0LjMxODAyIDQuNjAzNzkgMS4zMzMyNSA4LjI4NTY5IDEuMzMzMjVDMTEuOTY3NiAxLjMzMzI1IDE0Ljk1MjQgNC4zMTgwMiAxNC45NTI0IDcuOTk5OTJaTTguMjg1NjkgOC45NDI3M0w2Ljc1NzA5IDEwLjQ3MTNMNS44MTQyOCA5LjUyODUxTDcuMzQyODggNy45OTk5Mkw1LjgxNDI4IDYuNDcxMzJMNi43NTcwOSA1LjUyODUxTDguMjg1NjkgNy4wNTcxMUw5LjgxNDI4IDUuNTI4NTFMMTAuNzU3MSA2LjQ3MTMyTDkuMjI4NDkgNy45OTk5MkwxMC43NTcxIDkuNTI4NTFMOS44MTQyOCAxMC40NzEzTDguMjg1NjkgOC45NDI3M1oiIGZpbGw9IiNEQ0UxRTUiIGZpbGwtb3BhY2l0eT0iMC40MiIvPgo8L2c+Cjwvc3ZnPgo=";
export { SvgError as ReactComponent };